/*@ngInject*/
module.exports = function componentsService($http) {

    this.getComponent = function(componentId) {
        return $http.get('objectComponents/getComponent/' + componentId);
    };

};


/** WEBPACK FOOTER **
 ** ./app/shared/services/components.service.js
 **/